import React from 'react';
// import { Menu, Bell, User } from 'lucide-react';

const Header = ({ setSidebarOpen }) => { 
  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      {/* <div className="flex items-center justify-between px-6 py-4"> */}
        {/* <div className="flex items-center">
          <button
            onClick={() => setSidebarOpen(true)}
            className="lg:hidden p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100"
          >
            <Menu className="h-6 w-6" />
          </button>
          <h1 className="ml-4 lg:ml-0 text-2xl font-bold text-gray-900">
            News Admin Panellll
          </h1>
        </div> */}
        
        {/* <div className="flex items-center space-x-4">
          <button className="p-2 rounded-full text-gray-600 hover:text-gray-900 hover:bg-gray-100">
            <Bell className="h-6 w-6" />
          </button>
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-primary-600 rounded-full flex items-center justify-center">
              <User className="h-5 w-5 text-white" />
            </div>
            <span className="text-sm font-medium text-gray-700">Admin</span>
          </div>
        </div> */}
      {/* </div> */}
    </header>
  );
};

export default Header;





























// import React from 'react';
// import { Menu, Bell, User } from 'lucide-react';

// const Header = ({ setSidebarOpen }) => {
//   return (
//     <header className="bg-white shadow-sm border-b border-gray-200">
//       <div className="flex items-center justify-between px-6 py-4">
//         <div className="flex items-center">
//           <button
//             onClick={() => setSidebarOpen(true)}
//             className="lg:hidden p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100"
//           >
//             <Menu className="h-6 w-6" />
//           </button>
//           <h1 className="ml-4 lg:ml-0 text-2xl font-bold text-gray-900">
//             News Admin Panel
//           </h1>
//         </div>
        
//         <div className="flex items-center space-x-4">
//           <button className="p-2 rounded-full text-gray-600 hover:text-gray-900 hover:bg-gray-100">
//             <Bell className="h-6 w-6" />
//           </button>
//           <div className="flex items-center space-x-2">
//             <div className="w-8 h-8 bg-primary-600 rounded-full flex items-center justify-center">
//               <User className="h-5 w-5 text-white" />
//             </div>
//             <span className="text-sm font-medium text-gray-700">Admin</span>
//           </div>
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Header;